import { useState } from 'react';
import { Task } from '../../types';
import {
    DraftSelectionInteraction, DraftTaskSelection, DraggingTask, ResizingTask, TimelineScale,
} from './types';

export const usePlannerState = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [timelineScale, setTimelineScale] = useState<TimelineScale>('day');
    const [timelineWindow, setTimelineWindow] = useState({ start: 0, end: 0 });
    const [activeTimelineLabel, setActiveTimelineLabel] = useState('');
    const [activeTimelineDateKey, setActiveTimelineDateKey] = useState('');
    const [showSchedule, setShowSchedule] = useState(true);
    const [showCompletedTasks, setShowCompletedTasks] = useState(false);
    const [showAddTask, setShowAddTask] = useState(false);
    const [addTaskDate, setAddTaskDate] = useState<Date | null>(null);
    const [addTaskTime, setAddTaskTime] = useState<string | null>(null);
    const [addTaskDuration, setAddTaskDuration] = useState(60);
    const [isFlexibleTask, setIsFlexibleTask] = useState(false);
    const [flexiblePrecision, setFlexiblePrecision] = useState<Exclude<NonNullable<Task['schedule']>['precision'], 'hour'>>('day');
    const [flexibleInterval, setFlexibleInterval] = useState(1);
    const [flexibleEndDate, setFlexibleEndDate] = useState<Date | null>(null);
    const [newTaskTitle, setNewTaskTitle] = useState('');
    const [editingTask, setEditingTask] = useState<Task | null>(null);
    const [editingCollectionId, setEditingCollectionId] = useState<string | null>(null);
    const [existingTaskPickerDate, setExistingTaskPickerDate] = useState<Date | 'global' | null>(null);
    const [fixedScheduleDate, setFixedScheduleDate] = useState<Date | null>(null);
    const [timeSlotHeight, setTimeSlotHeight] = useState(56);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartHour, setDragStartHour] = useState<number | null>(null);
    const [dragStartY, setDragStartY] = useState<number | null>(null);
    const [dragStartOffset, setDragStartOffset] = useState(0);
    const [hasDragged, setHasDragged] = useState(false);
    const [draggingTask, setDraggingTask] = useState<DraggingTask | null>(null);
    const [dragTaskStartY, setDragTaskStartY] = useState<number | null>(null);
    const [dragTaskStartTopY, setDragTaskStartTopY] = useState<number | null>(null);
    const [dragTaskScrollTop, setDragTaskScrollTop] = useState(0);
    const [resizingTask, setResizingTask] = useState<ResizingTask | null>(null);
    const [resizeStartY, setResizeStartY] = useState<number | null>(null);
    const [resizeStartDuration, setResizeStartDuration] = useState(0);
    const [currentMouseY, setCurrentMouseY] = useState<number | null>(null);
    const [pendingTouchCreate, setPendingTouchCreate] = useState(false);
    const [draftSelection, setDraftSelection] = useState<DraftTaskSelection | null>(null);
    const [draftInteraction, setDraftInteraction] = useState<DraftSelectionInteraction | null>(null);
    return {
        selectedDate, setSelectedDate, timelineScale, setTimelineScale, timelineWindow, setTimelineWindow,
        activeTimelineLabel, setActiveTimelineLabel, activeTimelineDateKey, setActiveTimelineDateKey,
        showSchedule, setShowSchedule, showCompletedTasks, setShowCompletedTasks,
        showAddTask, setShowAddTask, addTaskDate, setAddTaskDate, addTaskTime, setAddTaskTime,
        addTaskDuration, setAddTaskDuration, isFlexibleTask, setIsFlexibleTask,
        flexiblePrecision, setFlexiblePrecision, flexibleInterval, setFlexibleInterval,
        flexibleEndDate, setFlexibleEndDate, newTaskTitle, setNewTaskTitle, editingTask, setEditingTask,
        editingCollectionId, setEditingCollectionId, existingTaskPickerDate, setExistingTaskPickerDate,
        fixedScheduleDate, setFixedScheduleDate, timeSlotHeight, setTimeSlotHeight, isDragging, setIsDragging,
        dragStartHour, setDragStartHour, dragStartY, setDragStartY, dragStartOffset, setDragStartOffset,
        hasDragged, setHasDragged, draggingTask, setDraggingTask, dragTaskStartY, setDragTaskStartY,
        dragTaskStartTopY, setDragTaskStartTopY,
        dragTaskScrollTop, setDragTaskScrollTop,
        resizingTask, setResizingTask, resizeStartY, setResizeStartY,
        resizeStartDuration, setResizeStartDuration, currentMouseY, setCurrentMouseY,
        pendingTouchCreate, setPendingTouchCreate, draftSelection, setDraftSelection,
        draftInteraction, setDraftInteraction,
    };
};

export type PlannerState = ReturnType<typeof usePlannerState>;
